import DraftOffsetKey from "draft-js/lib/DraftOffsetKey";

/**
 * @param   {EditorState} editorState
 * @param   {[]Record}    offsetKeys
 * @returns {[]Record}
 */
export default function findOffsetKeysLeaves(editorState, offsetKeys) {
  const currentSelection = editorState.getSelection();
  const anchorKey = currentSelection.getAnchorKey();

  return offsetKeys
    .map(DraftOffsetKey.decode)
    .filter(decodedOffsetKey => decodedOffsetKey.blockKey === anchorKey)
    .map(decodedOffsetKey =>
      editorState
        .getBlockTree(decodedOffsetKey.blockKey)
        .getIn([
          decodedOffsetKey.decoratorKey,
          "leaves",
          decodedOffsetKey.leafKey,
        ]),
    )
    .filter(Boolean);
}
